export default __webpack_public_path__ + "static/media/app_screen1.53d67682.png";